var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"async-button",class:{ pending: _vm.pending },on:{"click":_vm.clicked}},[(_vm.pending)?_c('div',{staticClass:"spinner",class:{ show: _vm.pending }},[_c('loading-spinner',{attrs:{"size":_vm.LoadingSpinnerSize.Small}})],1):_vm._e(),_c('div',{staticClass:"text",class:{ show: !_vm.pending }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }